<template>
    <b-card no-body class="station-wrapper">
        <b-card-header class="collapse-card-header station-header" v-b-toggle="`collapse-estacion-card-${station.id}`">
            {{station.descrip}}
        </b-card-header>
        <b-collapse :id="`collapse-estacion-card-${station.id}`" visible>
            <b-card-body class="p-0">
                <div class="machines-list">
                    <Machine
                        :ref="`equipo-${machine.id}`"
                        v-for="machine in station.machines"
                        :key="machine.id"
                        :machine="machine"
                        :productionLineCollapseId="productionLineCollapseId"
                    ></Machine>
                </div>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
import Machine from "./Machine";
export default {
    name: "Station",
    components:{
        Machine
    },
    props:{
        station: Object,
        productionLineCollapseId: String
    },
    data(){
        return{

        }
    },
    mounted(){

    }
}
</script>